module.exports = __webpack_public_path__ + "assets/img/title.7c01d864.png";